import { __rest } from "tslib";
import React, { useEffect, useRef } from 'react';
import { apiHolder as api, apis } from 'api';
import UploadAttachment from '../UploadAttachment';
import { useAppDispatch, } from '@web-common/state/createStore';
import { MAIL_EDITOR_CONTAINER_CLASS } from './editor-config';
const trackApi = api.api.requireLogicalApi(apis.dataTrackerApiImp);
const HOCEditorExtend = (Component) => {
    const UploadPlaceholder = props => {
        var _a;
        const { forwardedRef, onEditCreated } = props, rest = __rest(props, ["forwardedRef", "onEditCreated"]);
        const dispatch = useAppDispatch();
        const bodyObserverRef = useRef(null);
        const uploadAttachmentRef = useRef(null);
        const bodyObserver = (ed) => {
            const editorBody = ed.getBody();
            const container = document.querySelector(`.${MAIL_EDITOR_CONTAINER_CLASS}`);
            const overflowContainer = document.querySelector(`.${MAIL_EDITOR_CONTAINER_CLASS} .tox-tinymce`);
            if (!container)
                return;
            const resizeOb = new ResizeObserver(entries => {
                const offsetWidth = editorBody.scrollWidth;
                if (overflowContainer && container) {
                    const containerWidth = container.clientWidth;
                    let width = offsetWidth;
                    if (containerWidth > width) {
                        width = containerWidth;
                    }
                    overflowContainer.style.width = width + 'px';
                    editorBody.style.width = containerWidth + 'px';
                }
            });
            bodyObserverRef.current = resizeOb;
            resizeOb.observe(editorBody);
            resizeOb.observe(container);
        };
        useEffect(() => {
            return () => {
                bodyObserverRef.current && bodyObserverRef.current.disconnect();
            };
        }, []);
        const editorSetup = (ed) => {
            bodyObserver(ed);
            onEditCreated(ed);
        };
        return (React.createElement(React.Fragment, null,
            React.createElement(UploadAttachment, { ref: uploadAttachmentRef }),
            React.createElement(Component, Object.assign({ onEditCreated: editorSetup }, rest, { ref: forwardedRef, uploadAttachment: (_a = uploadAttachmentRef.current) === null || _a === void 0 ? void 0 : _a.upload }))));
    };
    return React.forwardRef((props, ref) => React.createElement(UploadPlaceholder, Object.assign({}, props, { forwardedRef: ref })));
};
export default HOCEditorExtend;
